















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class StatsCard extends Vue {
    @Prop(String) readonly title!: string;

    @Prop(Number) readonly count!: number;

    @Prop(String) readonly color!: string;

    get bgClass(): string {
        const colors: Record<string, string> = {
            yellow: 'bg-yellow-50',
            green: 'bg-green-50',
            red: 'bg-red-50',
            blue: 'bg-blue-50',
        };
        return colors[this.color] || 'bg-gray-50';
    }

    get borderClass(): string {
        const colors: Record<string, string> = {
            yellow: 'border-yellow-500',
            green: 'border-green-500',
            red: 'border-red-500',
            blue: 'border-blue-500',
        };
        return colors[this.color] || 'border-gray-500';
    }

    get textClass(): string {
        const colors: Record<string, string> = {
            yellow: 'text-yellow-500',
            green: 'text-green-500',
            red: 'text-red-500',
            blue: 'text-blue-500',
        };
        return colors[this.color] || 'text-gray-500';
    }
}
